import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  path?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑" className="flex items-center flex-wrap gap-1.5 text-sm">
      <Link to="/" className="text-foreground-500 hover:text-primary-700 transition-colors cursor-pointer">
        首页
      </Link>
      {items.map((item, idx) => (
        <span key={idx} className="flex items-center gap-1.5">
          <i className="ri-arrow-right-s-line text-foreground-400"></i>
          {item.path ? (
            <Link
              to={item.path}
              className="text-foreground-500 hover:text-primary-700 transition-colors cursor-pointer"
            >
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-900 font-medium">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}